<template>
    <div style="background: #eaeaea" class="mb-2">
        <v-window v-model="step">
            <v-window-item :value="0">
                <TaxFormTable @editTaxFrom="editTaxFrom" />
            </v-window-item>
            <v-window-item :value="1">
                <UploadTaxFrom @forms="setForms($event)" @routeBack="step = 0" />
            </v-window-item>
            <v-window-item :value="2">
                <v-row no-gutters>
                    <v-col cols="6">
                        <v-btn-back @click="step = 0" />
                    </v-col>
                    <v-col cols="2" class="d-flex justify-center pa-2">
                        <v-btn-toggle v-model="displayTaxFromMode" group shaped mandatory="force">
                            <v-btn value="TaxFormTable" class="mx-0"> Saisie </v-btn>
                            <v-btn value="TaxFormPng" class="ml-2"> Cerfa </v-btn>
                        </v-btn-toggle>
                    </v-col>
                    <v-col cols="4" class="d-flex justify-center align-center pa-2">
                        <v-select
                            v-model="millesim"
                            :items="millesimItems"
                            outlined
                            hide-details
                            label="Choix du millésime"
                            style="width: 70%"
                            density="compact"
                        />
                        <v-btn @click="updateTaxFrom" rounded class="mx-2" elevation="0">
                            {{ taxFormId ? "Mettre a jour" : "Ajouter" }}
                        </v-btn>
                    </v-col>
                    <v-col cols="12">
                        <TaxForm
                            v-if="displayTaxFrom"
                            :fieldsChild="fields"
                            :formInput="forms.form"
                            :rulesInput="forms.rules"
                            :valuesInput="forms.values"
                            :cerfaInput="forms.cerfa"
                            :imageInput="forms.imageUrl"
                            :activeTab="displayTaxFromMode"
                            :loaded="true"
                        />
                    </v-col>
                </v-row>
            </v-window-item>
        </v-window>
    </div>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";

import TaxForm from "../TaxForm.vue";
import TaxFormTable from "./TablePlayground.vue";
import UploadTaxFrom from "./UploadTaxForm.vue";

import FORM_TAX_FORM from "@/graphql/taxForm/FormTaxForm.gql";
import UPSERT_TAX_FORM from "@/graphql/taxForm/UpsertTaxForm.gql";
import { SheetManager } from "../../../../../backend/src/common/taxform/SheetManager";
import { BundleFront } from "@/services/bundle/BundleFront";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Provide } from "vue-facing-decorator";

@Component({
    components: {
        TaxForm,
        TaxFormTable,
        UploadTaxFrom,
    },
})
export class TaxFormDisplayPlayground extends Vue {
    @Provide("taxFormFocusFromConsistencyCheck") focusSpec = "";

    step = 0;

    taxFormId = "";
    millesim = 2023;

    loaded = false;
    fields: any;

    displayTaxFromMode = "TaxFormTable";

    bundle: BundleFront = null;

    @Apollo({
        query: FORM_TAX_FORM,
        variables() {
            return {
                id: this.taxFormId,
            };
        },
        skip() {
            return !this.taxFormId;
        },
        result({ data }) {
            if (data?.declarationForm?.form) {
                this.setForms({
                    form: data.declarationForm.form.form,
                    rules: data.declarationForm.form.rules,
                    values: data.declarationForm.form.values,
                    cerfa: data.declarationForm.form.cerfa,
                    image: data.declarationForm.image,
                });
            }
        },
    })
    forms: SheetManager = null;

    get displayTaxFrom() {
        return this.forms;
    }

    get millesimItems() {
        const moment = require("moment-timezone");
        let year: any = moment().year();
        year = year + 1;
        return [year, year - 1, year - 2, year - 3].sort().reverse();
    }

    editTaxFrom(id: string) {
        if (id) {
            this.taxFormId = id;
            this.step = 2;
        } else {
            this.taxFormId = "";
            this.step = 1;
        }
    }

    async updateTaxFrom(status = "EDITION") {
        await this.$apollo.mutate({
            mutation: UPSERT_TAX_FORM,
            variables: {
                id: this.taxFormId,
                cerfa: this.forms.cerfa,
                form: this.forms.form,
                image: this.forms.imageUrl,
                rules: this.forms.rules,
                values: this.forms.values,
                millesim: this.millesim,
                status,
            },
        });
    }

    setForms(forms: { rules: any; form: any; cerfa: any; values: any; image: string; id: string }) {
        this.loaded = true;
        this.forms = new SheetManager("", forms, {}, null, null);
        debugger;
        const fullFields = this.forms.getFields();
        const keys = Object.keys(fullFields);
        const fields = {};
        keys.forEach((key) => {
            const currentField = fullFields[key];
            fields[currentField.key] = currentField;
        });
        this.fields = fields;
        this.step = 2;
    }
}

export default toNative(TaxFormDisplayPlayground);
</script>
